module.exports = __webpack_public_path__ + "static/img/dx.948e8b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/dx.png
// module id = 9YA9
// module chunks = 1